var map = {
	"./ag_casino.png": 67347,
	"./dg_casino.png": 66946,
	"./ebet_casino.png": 29053,
	"./evl_casino.png": 41298,
	"./pragmatic_casino.png": 99055,
	"./pt-live.png": 53454,
	"./sa_casino.png": 91967,
	"./sg_casino.png": 89165,
	"./tin888.png": 20338,
	"./wm_casino.png": 74223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39234;